







import { Vue } from "vue-property-decorator";

export default class VServiceTaskTableCell extends Vue {}
